import axios from 'axios';
import Vue from 'vue';

const state = {
    hourlyRates: {},
    loading: false,
    error: null,
};

const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },

    SET_ERROR(state, error) {
        state.error = error;
    },

    SET_HOURLY_RATE(state, { driverNumber, hourlyRate }) {
        Vue.set(state.hourlyRates, driverNumber, hourlyRate);
    },

    SET_HOURLY_RATES(state, rates) {
        state.hourlyRates = { ...rates };
    },
};

const actions = {
    async fetchDriverHourlyRate({ commit, state }, driverNumber) {
        if (state.hourlyRates[driverNumber] !== undefined) {
            return state.hourlyRates[driverNumber];
        }

        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        try {
            const url = `${import.meta.env.VITE_API_BASE_URL}/cpanel/drivers/${driverNumber}`;
            const response = await axios.get(url, {
                withCredentials: true,
            });

            const hourlyWageInCents =
                response.data?.hourlyWage || response.data?.hourly_wage || null;

            if (hourlyWageInCents !== null && hourlyWageInCents !== undefined) {
                const hourlyWageInEuros = parseFloat(hourlyWageInCents) / 100;
                commit('SET_HOURLY_RATE', { driverNumber, hourlyRate: hourlyWageInEuros });
                return hourlyWageInEuros;
            }

            commit('SET_HOURLY_RATE', { driverNumber, hourlyRate: null });
            return null;
        } catch (error) {
            commit('SET_ERROR', error);
            return null;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async updateDriverHourlyRate({ commit }, { driverNumber, hourlyWage }) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        try {
            const hourlyWageInCents = Math.round(parseFloat(hourlyWage) * 100);
            const url = `${import.meta.env.VITE_API_BASE_URL}/cpanel/drivers/${driverNumber}`;
            await axios.put(
                url,
                { hourlyWage: hourlyWageInCents },
                {
                    withCredentials: true,
                },
            );

            commit('SET_HOURLY_RATE', { driverNumber, hourlyRate: parseFloat(hourlyWage) });

            return parseFloat(hourlyWage);
        } catch (error) {
            commit('SET_ERROR', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },
};

const getters = {
    getHourlyRate: (state) => (driverNumber) => {
        return state.hourlyRates[driverNumber] || null;
    },

    isLoading: (state) => state.loading,
    getError: (state) => state.error,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
